import BarChartIcon from "@mui/icons-material/BarChart";
import { Box, Typography } from "@mui/material";

const NoDataToDisplay = ({ message = "No data available", loading = false }) => {
   return (
      <Box
         display="flex"
         flexDirection="column"
         alignItems="center"
         justifyContent="center"
         height={300}
         bgcolor="white"
         borderRadius={2}
         p={3}
      >
         {!loading && <BarChartIcon fontSize="large" color="disabled" />}
         <Typography variant="h6" color="textSecondary" mt={1}>
            {loading ? 'Loading...' : message}
         </Typography>
      </Box>
   );
};

export default NoDataToDisplay;
